/** @format */

import React from "react";
import Avatar from "@mui/material/Avatar";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import SendIcon from "@mui/icons-material/Send";
import LoadingButton from "@mui/lab/LoadingButton";
import PasswordComponent from "../Components/PasswordComponent";
import { NavLink } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../Contexts/useAuth";
import PasswordResetModel from "../Components/PasswordResetModel";
import { useState, useEffect } from "react";

/*function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://mui.com/">
        Your Website
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}*/

// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();

export default function SignIn() {
  const location = useLocation();
  const navigate = useNavigate();
  const { signIn, authed } = useAuth();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setError] = useState({});
  const [open, setOpen] = useState(true);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const [openModel, setOpenModel] = useState(false);

  const handleModelOpen = () => {
    setOpenModel(true);
  };

  const handleModelClose = () => {
    setOpenModel(false);
  };

  const handleSubmit = async (event) => {
    setLoading(true);
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    let authResult = {};

    await axios
      .post(`${process.env.REACT_APP_API_URL}/api/v1/auth/authenticate`, {
        username: data.get("email"),
        password: data.get("password"),
      })
      .then((loginResponse) => {
        authResult = loginResponse.data;
        console.log(authResult);
        signIn(authResult);
        setLoading(false);
        location.state?.whoLogin === "admin"
          ? navigate(-1)
          : navigate("/dashboard");
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data);
          setError({ isError: true, errorMessage: error.response.data.desc });
          setOpen(true);
          setLoading(false);
        }
      });
  };

  useEffect(() => {
    console.log(err);
  }, [err]);

  useEffect(() => {
    console.log(location);
  }, [location]);

  useEffect(() => {
    if (location.state?.whoLogin === undefined) {
      if (authed) {
        navigate("/dashboard");
      }
    }
  }, [authed]);

  return (
    <>
      <PasswordResetModel isOpen={openModel} handleClose={handleModelClose} />
      <ThemeProvider theme={defaultTheme}>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <Box
            sx={{
              marginTop: 8,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in
            </Typography>
            <Box
              component="form"
              onSubmit={handleSubmit}
              sx={{ mt: 1 }}
            >
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
              />
              <PasswordComponent
                name="password"
                label="Password"
                value={password}
                setValue={setPassword}
              />

              <LoadingButton
                type="submit"
                fullWidth
                endIcon={<SendIcon />}
                loading={loading}
                loadingPosition="end"
                variant="contained"
                sx={{ mt: 3, mb: 2, bgcolor: "secondary.main" }}
              >
                {location.state?.whoLogin === "admin"
                  ? "Admin Login"
                  : "Sign In"}
              </LoadingButton>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: 2,
                  mt: 2,
                }}
              >
                <Typography
                  sx={{
                    cursor: "pointer",
                    "&:hover": {
                      color: "#1976d2",
                    },
                  }}
                  onClick={() => handleModelOpen()}
                >
                  Forgot password?
                </Typography>

                <NavLink to="/sign-up" variant="body2">
                  {"Don't have an account? Register here"}
                </NavLink>
              </Box>
            </Box>
          </Box>
          {err.isError && (
            <div>
              <Snackbar
                open={open}
                autoHideDuration={10000}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              >
                <Alert
                  onClose={handleClose}
                  severity="error"
                  variant="filled"
                  sx={{ width: "100%" }}
                >
                  {err.errorMessage}
                </Alert>
              </Snackbar>
            </div>
          )}

          {/*<Copyright sx={{ mt: 8, mb: 4 }} />*/}
        </Container>
      </ThemeProvider>
    </>
  );
}
